import {
  Box,
  BoxProps,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'

import { useStyles } from './styles'

export type Privacy = 'corporate' | 'private'

interface VisibilityProps {
  title: string
  privacy: string
  handleIsPrivate: (state: Privacy) => void
  containerProps?: BoxProps
}

export function Visibility({
  title,
  privacy,
  handleIsPrivate,
  containerProps,
}: VisibilityProps) {
  const classes = useStyles()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleIsPrivate(event.target.value as Privacy)
  }

  return (
    <Box {...containerProps}>
      <Typography variant='h3' className={classes.title} color='textSecondary'>
        {title}
      </Typography>
      <FormControl component='fieldset' className={classes.fieldset}>
        <RadioGroup
          row
          aria-label='Visibilidade'
          value={privacy}
          onChange={handleChange}
        >
          <FormControlLabel
            value='corporate'
            control={
              <Radio
                classes={{
                  root: classes.radioRoot,
                }}
              />
            }
            label={
              <Box
                display='flex'
                alignItems='center'
                gridGap='0.5rem'
                className={classes.formControlLabelRoot}
              >
                <span className='material-symbols-outlined'>
                  corporate_fare
                </span>
                <section>
                  <div>Corporativo</div>
                  <span>Toda a companhia terá acesso à esta unidade.</span>
                </section>
              </Box>
            }
          />
          <FormControlLabel
            value='private'
            control={
              <Radio
                classes={{
                  root: classes.radioRoot,
                }}
              />
            }
            label={
              <Box
                display='flex'
                alignItems='center'
                gridGap='0.5rem'
                className={classes.formControlLabelRoot}
              >
                <span className='material-symbols-outlined'>
                  admin_panel_settings
                </span>
                <section>
                  <div>Privado</div>
                  <span>
                    Apenas pessoas selecionadas tem acesso à esta unidade.
                  </span>
                </section>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}
